import { useState } from "react";
import { FieldError, Textarea } from "core/components/Form/styles";
import Button from "core/components/Button";
import Success from "core/components/Success";

const ImportLicenseForm = ({ onSubmit }) => {
  const [importValue, setImportValue] = useState("");
  const [error, setError] = useState("");
  const [importSuccess, setImportSuccess] = useState("");

  const handleChange = (event) => {
    const value = event.target.value;
    setImportSuccess("");

    try {
      setImportValue(value);
      JSON.parse(event.target.value);
      setError("");
    } catch (error) {
      console.error(error);
      setError("Must be in JSON format.");
    }
  };

  const handleSubmit = () => {
    onSubmit(JSON.parse(importValue));
    setError("");
    setImportValue("");
    setImportSuccess("Import successful. Check draft changes.");
  };

  return (
    <div>
      <Success style={{ marginBottom: "10px" }}>{importSuccess}</Success>
      <Textarea
        rows="20"
        style={{ maxWidth: "400px", width: "325px" }}
        value={importValue}
        onChange={handleChange}
        placeholder="Add product license JSON"
      />
      <FieldError>{error}</FieldError>
      <Button disabled={!importValue || error} onClick={handleSubmit}>
        Import
      </Button>
    </div>
  );
};

export default ImportLicenseForm;
